module.exports = __webpack_public_path__ + "img/album13_01.29b2346a.jpg";